import axios from 'axios';

const BASE_URL = import.meta.env.VITE_URL_SERVICE;

/**
 * Core HTTP client using Axios.
 *
 * Provides base URL and default headers.
 * Authentication (Bearer tokens from Auth0) and automatic token refreshing
 * should be handled by a dedicated interceptor provider wrapping the application.
 */
export const httpClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});
